if ('serviceWorker' in navigator && !window.webpushSwRegistered) {
    window.addEventListener('load', async () => {
        try {
            const registration = await navigator.serviceWorker.register('/sw-webpush.js', {
                updateViaCache: 'none',
            });

            await registration.update();
            window.webpushSwRegistered = true;
        } catch (error) {
            console.error('Service Worker registration failed:', error);
        }
    });
}
